var map = {
	"./1.webp": 7538,
	"./10.webp": 6912,
	"./11.webp": 4288,
	"./12.webp": 1615,
	"./13.webp": 9405,
	"./14.webp": 1888,
	"./15.webp": 87,
	"./16.webp": 7211,
	"./17.webp": 9231,
	"./18.webp": 9492,
	"./19.webp": 7864,
	"./2.webp": 474,
	"./20.webp": 3342,
	"./21.webp": 6255,
	"./22.webp": 2779,
	"./3.webp": 8157,
	"./4.webp": 9855,
	"./5.webp": 9036,
	"./6.webp": 6832,
	"./7.webp": 5157,
	"./8.webp": 7838,
	"./9.webp": 2816,
	"./cardBack.webp": 2383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9766;